module.exports = __webpack_public_path__ + "static/media/S1N2-3.28d96e1e.svg";